import { Link as RouterLink } from "react-router-dom";
import {
  List,
  ListItemButton,
  ListItemAvatar,
  Avatar,
  ListItemText,
  ListItemIcon,
} from "@mui/material";
import { getOrderStatusColor, getOrderStatusString } from "utilities/orders";
import { SimpleOrder } from "models/SimpleOrder";
import { ArrowForwardIos } from "@mui/icons-material";

type MobileOrdersListProps = { orders: SimpleOrder[] };

const MobileOrdersList: React.FC<MobileOrdersListProps> = (props) => {
  const { orders } = props;

  return (
    <List disablePadding>
      {orders.map((order) => (
        <ListItemButton
          key={order.ordernr}
          component={RouterLink}
          to={`/orders/view/${order.ordernr}`}
          divider
          disableGutters
        >
          <ListItemAvatar>
            <Avatar
              sx={(theme) => ({
                color: theme.palette.primary.contrastText,
                bgcolor: getOrderStatusColor(order.orderStatus),
              })}
            >
              {getOrderStatusString(order.orderStatus)}
            </Avatar>
          </ListItemAvatar>

          <ListItemText primary={order.ordernr} secondary={order.companyName} />

          <ListItemIcon sx={{ minWidth: "auto" }}>
            <ArrowForwardIos color="disabled" />
          </ListItemIcon>
        </ListItemButton>
      ))}
    </List>
  );
};

export default MobileOrdersList;
